import { useState, useEffect } from "react";
import { useQuery } from "@apollo/react-hooks";
import { GetProductReport } from "./queries";
import { endOfDate } from "../../helpers/DateManipulation";
import _ from "lodash";
import moment from "moment";
import { useHistory } from "react-router-dom";

function useProductReport({ product }) {
  const history = useHistory();

  const [filters, setFilters] = useState({
    date: [
      moment()
        .subtract(3, "months")
        .toDate(),
      new Date()
    ]
  });

  const { loading, data, error } = useQuery(GetProductReport, {
    variables: {
      productId: product,
      date: {
        greaterThanOrEqual: filters.date[0].toUTCString(),
        lessThanOrEqual: endOfDate(filters.date[1]).toUTCString()
      }
    }
  });

  const filterOptions = buildFilterOptions();

  if (!!error) history.push("/reporting");

  return {
    loading: loading || error,
    productReport:
      loading || error || !data ? undefined : data.reports.productReport,
    filters,
    filterOptions,
    setFilters
  };
}

const buildFilterOptions = () => [
  {
    key: "date",
    label: "Date Range",
    type: "dateRange",
    required: true
  }
];

export default useProductReport;
